import { calcNbrMonthsBtwnDates } from "../../../objects/CommonUse/nbr_months_btwn_dates_calc";
import stepStoneReplaceText from "./step_stone_replace_text";


export const determineIfStepStoneJob = (jobStartDate, currentGameDate, relatedCareers,
        currentCareerName, currentNbrYearsCollege, newCareerName ) => {
    //  determine how many months the individual has been working in their current career
    let careerNbrMonths = calcNbrMonthsBtwnDates(jobStartDate, currentGameDate);
    let stepStoneCareerName = "";
    let stepStoneType = "";
    let stepStoneTextObj = {};
    for (let i=0; i<relatedCareers.length; i++){
         let relatedCareerObj = relatedCareers[i];
         if (relatedCareerObj.stepStone === true){  
                if (currentCareerName  !== relatedCareerObj.jobName &&
                    currentNbrYearsCollege !== 0){
                      stepStoneType = "College"
                      stepStoneCareerName = relatedCareerObj.jobName;
                      stepStoneTextObj = stepStoneReplaceText(stepStoneType, newCareerName,
                        stepStoneCareerName, careerNbrMonths);
                }
                if (currentCareerName  === relatedCareerObj.jobName &&
                    careerNbrMonths < 24){ 
                       stepStoneType = "JobExperiencePartial"
                       stepStoneCareerName = relatedCareerObj.jobName;
                       stepStoneTextObj = stepStoneReplaceText(stepStoneType, newCareerName,
                            stepStoneCareerName, careerNbrMonths);
                }
                if (currentCareerName  !== relatedCareerObj.jobName &&
                  currentNbrYearsCollege === 0){ 
                     stepStoneType = "JobExperienceNone"
                     stepStoneCareerName = relatedCareerObj.jobName;
                     stepStoneTextObj = stepStoneReplaceText(stepStoneType, newCareerName,
                        stepStoneCareerName, careerNbrMonths);
                }
         }
    } 
    let shortStepStoneText = "";
    let stepStoneFullText = "";
    if (stepStoneTextObj.shortStepStoneText){
        shortStepStoneText = stepStoneTextObj.shortStepStoneText;
    }
    if (stepStoneTextObj.stepStoneFullText){
        stepStoneFullText = stepStoneTextObj.stepStoneFullText;
    }
    const returnObj = {stepStoneType: stepStoneType, stepStoneCareerName: stepStoneCareerName,
        shortStepStoneText: shortStepStoneText, stepStoneFullText: stepStoneFullText,
        careerNbrMonths: careerNbrMonths };
    return returnObj;
}
export default determineIfStepStoneJob;